import React from 'react';

// Month selection the way the Customer (dispatch) Report does it: a range
// with "Last 2 / 3 / 6 months" shortcuts, or individual months picked from
// the last two years (they need not be consecutive). Values are 'YYYY-MM'.

export const thisMonth = () => new Date().toISOString().slice(0, 7);
export const shiftMonth = (ym, delta) => {
  const [y, m] = ym.split('-').map(Number);
  const d = new Date(y, m - 1 + delta, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};
export const monthLabel = (ym) => {
  const [y, m] = String(ym || '').split('-').map(Number);
  if (!y || !m) return ym || '';
  return new Date(y, m - 1, 1).toLocaleDateString('en-IN', { month: 'short', year: 'numeric' });
};
export const recentMonths = (count = 24) => Array.from({ length: count }, (_, i) => shiftMonth(thisMonth(), -i));

// "Last 2 / 3 / 6 months" shortcuts for a from–to range.
export function RangeShortcuts({ onPick, className = '' }) {
  return (
    <div className={`flex flex-wrap gap-1 ${className}`}>
      {[[2, 'Last 2 months'], [3, 'Last 3 months'], [6, 'Last 6 months']].map(([n, l]) => (
        <button key={n} type="button" onClick={() => onPick(shiftMonth(thisMonth(), -(n - 1)), thisMonth())}
          className="text-[11px] px-2 py-0.5 rounded bg-slate-100 text-slate-600 hover:bg-slate-200">{l}</button>
      ))}
    </div>
  );
}

// Click months on and off; `value` is the array of picked 'YYYY-MM'.
export function MonthChips({ value = [], onChange, count = 24, className = '' }) {
  const toggle = (m) => onChange(value.includes(m) ? value.filter(x => x !== m) : [...value, m].sort());
  return (
    <div className={`flex flex-wrap gap-1 max-h-28 overflow-y-auto ${className}`}>
      {recentMonths(count).map(m => (
        <button key={m} type="button" onClick={() => toggle(m)}
          className={`text-[11px] px-2 py-0.5 rounded border ${value.includes(m) ? 'bg-indigo-600 border-indigo-600 text-white font-semibold' : 'bg-white border-slate-200 text-slate-600 hover:bg-slate-50'}`}>
          {monthLabel(m)}
        </button>
      ))}
    </div>
  );
}
